//
// Card Board
//
// ---------------------------------------------------------------------------

'use strict';

import Masonry from 'masonry-layout';
import ImagesLoaded from 'imagesloaded';

ImagesLoaded.makeJQueryPlugin( $ );

const config = {
    target: '.js-card-board',
    itemSelector: '.c-content-card',
    loadMoreSelector: '.js-load-more',
    loadingModifier: 'c-button--loading',
    nodeTypesAttr: 'node-types',
    nodeIdAttr: 'node-id',
    limitAttr: 'limit',
    orderAttr: 'order',
    offsetAttr: 'offset',
    clickEvents: 'click touch',
    gutterWidth: 24
};

class CardBoard {

    constructor() {
        if(!$(config.target).length) {
            return;
        }

        this.bindElements();
        this.setupClickEvents();

        $(config.target).imagesLoaded(() => this.setupMasonry());
    }

    /**
     * Bind common elements
     */
    bindElements() {
        this.grid = document.querySelector(config.target);
        this.loadMoreButton = $(config.loadMoreSelector);
    }

    /**
     * Configure the Masonry component
     */
    setupMasonry() {
        this.msnry = new Masonry( this.grid, {
            itemSelector: config.itemSelector,
            gutter: config.gutterWidth,
            columnWidth: '.c-card-board__sizer',
            percentPosition: true
        });
    }

    /**
     * Calculate the new offset by taking the sum of the current offset and limit
     *
     * @returns {Integer}
     */
    calculateOffset() {
        const selector = $(config.loadMoreSelector);
        const limit = selector.data(config.limitAttr);

        let offset = selector.data(config.offsetAttr);

        if (isNaN(limit)) {
            return false;
        }

        if (isNaN(offset)) {
            offset = 0;
        }

        return parseInt(offset, 10) + parseInt(limit, 10);
    }

    /**
     * Sets up all click events for the CardBoard component
     */
    setupClickEvents() {
        $(config.loadMoreSelector).on(config.clickEvents, (e) => this.handleLoadMore(e));
    }

    /**
     * Handles the click of the load more event
     *
     * @param {event} e
     */
    handleLoadMore(e) {
        e.preventDefault();

        const that = $(e.target);
        const CardBoard = this;
        const url = that.data('url');
        const fragment = document.createDocumentFragment();
        const nodeTypes = that.data(config.nodeTypesAttr);
        const nodeId = that.data(config.nodeIdAttr);
        const order = that.data(config.orderAttr);
        const offset = that.data(config.offsetAttr);
        const limit = that.data(config.limitAttr);
        const elems = [];
        const params = {
            nodeTypes: nodeTypes,
            nodeId: nodeId,
            order: order,
            offset: offset,
            limit: limit
        }; // For these params, when data is not supplied, these are null and will not be sent in the ajax call

        // Block presses until we have finished loading
        if (that.hasClass(config.loadingModifier)) {
            return;
        }

        CardBoard.loadMoreButton.addClass(config.loadingModifier);

        $.get(url, params, function( response ) {
            // First thing is to increment the offset
            appendNewCards(CardBoard, response);
        });

        /**
         * Handler for ajax return in load more
         *
         * @param {CardBoard} CardBoard
         * @param {Object} response
         */
        function appendNewCards(CardBoard, response) {
            handleOffset(CardBoard);
            handleAppend(CardBoard, response);
            handleLoadMoreButton(CardBoard, response);
        }

        /**
         * We need to increment the offset for each request, so that if we fetch twice we get the next batch (like pagination)
         *
         * @param {CardBoard} CardBoard
         */
        function handleOffset(CardBoard) {
            const offset = CardBoard.calculateOffset();
            if (offset) {
                that.data(config.offsetAttr, offset);
            }
        }

        /**
         * Take the cards returned, append them to the parent and let Masonry know about them
         *
         * @param {CardBoard} CardBoard
         * @param {Object} response
         */
        function handleAppend(CardBoard, response) {
            $(response).filter(config.itemSelector).each(function (index, value) {
                fragment.appendChild(value);
                elems.push(value);
            });

            // append elements to container
            CardBoard.grid.appendChild(fragment);

            let isLoaded = false;

            $(config.target).imagesLoaded( function() {
                if (!isLoaded) {
                    // add and lay out newly appended elements
                    CardBoard.msnry.appended(elems);
                    CardBoard.loadMoreButton.removeClass(config.loadingModifier);
                    isLoaded = true;
                }
            });
            // Just in case some images take longer to load
            setTimeout(function () {
                if (!isLoaded) {
                    // add and lay out newly appended elements
                    CardBoard.msnry.appended(elems);
                    CardBoard.loadMoreButton.removeClass(config.loadingModifier);
                    isLoaded = true;
                }
            }, 2000); // 2 seconds
        }

        /**
         * If we had less items returned than we asked for, we must have run out of items to load, so we can remove the button
         *
         * @param {CardBoard} CardBoard
         * @param {Object} response
         */
        function handleLoadMoreButton(CardBoard, response) {
            if ($(response).filter(config.itemSelector).length < limit) {
                CardBoard.loadMoreButton.parent().remove();
            }
        }
    }
}

$(window).load(function(){
    new CardBoard();
});



// WEBPACK FOOTER //
// ./src/js/components/card-board.js